export class CommonDTO {
  documentType: string;
  documentId: string;
  companyId: string;
  siteId: string;
  departmentId: string;
  templateId: string;
  auditProgramId: string;
  tableName: string;
  reqId: string;
  auditFirmId: string;
  clientId: string;
  wfType: string;
  searchValue: string;
  teamType: string; // auditor,auditee
  codeTypeId: string;
  codeDesc: string;
  userEmail: string;
  reqMstId: string;
  isWfReq: number;
  wfActionType: string;
  userId: string;

  mailFrom: string;
  mailTo: string;
  mailCc: string;
  auditProgramName: string;
  auditFirmName: string;
  companySiteName: string;
  financialYear: string;
  auditPeriod: string;
  auditeeTeam: string;
  auditorTeam: string;
  wfApprovedBy: string;
  wfSubmitBy: string;
  wfReturnedBy: string;
  wfTransferedBy: string;
  eventId: string;
  nextApproverName: string;
  nextApproverEmail: string;
  originatorName: string;
  originatorEmail: string;
  mailPreviewData: string;
  isLoginBased: boolean = true;
  sectionId: string;
  departmentName: string;
  sectionName: string;

  airItemId: string;
  auditorAction: string;
  auditeeAction: string;
  remarks: string;
  subMenuId: string;
  scopeId: string;

  cdAccessType: string;
  cdAreaPrivilegeScope: string;
  airTemplateId: string;

  umbrellaGroupId: number = 0;
  umbrellaGroupSettingId: number = 0;
  regionId: string = '';
  allDownload: string;
  actionType: string;
  reportType: string;
  userType: string;
  roleId: string;
  isPreviewAvailable: string = '0';
  isDraftReportReleased: string = '0';
  isFinalReportReleased: string = '0';

  //for download on audit detail
  pending: string = '0';
  inWf: string = '0';
  nc: string = '0';
  ncOpen: string = '0';
  ncClosed: string = '0';
  pnc: string = '0';
  pncOpen: string = '0';
  pncClosed: string = '0';
  closed: string = '0';
  na: string = '0';
  all: string = '0';
  returned: string = '0';
  notStarted: string = '0';
  plan: string = '0';
  doing: string = '0';
  check: string = '0';
  act: string = '0';
  riskRating: string = '0';
  riskRatingId: string = '0';
  scopePrivilege: string;
  isPnc: string = '';
  quarterType: string;

  forInforMationDisplay: boolean;

  mailForCoeRegion: boolean;
  typeScore: string;
  businessVerticalID: any;
  auditAreaId: any;
  financialYearId: any;
  startIndex: any;
  endIndex: any;
  auditId: any;
  privilegeScope: string;
  defaultScreenId: number;
  selectedCheckboxValue: boolean;
  getPreviousFinancialYear: string;
  regionName: string;
}
